import React from 'react';
import TicketList from '../it/TicketList';

function MyTickets() {
  return <TicketList isAdmin={false} />;
}

export default MyTickets;
